<template>
<v-container fluid>

  <v-snackbar
    v-model="snackbar"
    :color="snackbarColor"
    :top="true"
    :right="true"
    :timeout="0"
    absolute
    auto-height
  >
    {{ message }}
    <v-btn
      dark
      flat
      @click="snackbar = false"
    >
      CLOSE
    </v-btn>
  </v-snackbar>
  <v-col  class="d-flex justify-end">
            <v-btn color="#7BC243" v-if="$can('CAN_UPLOAD_FARMERS')" @click="showEditDialog(farmer)" class="white--text cataloguebtn">
              Create Farmer
            </v-btn>
          </v-col>
  <v-layout class="mt-0">
  <v-flex xs12>
    <div :class="paginatedFiles.length === 7 ? 'viewfarmer_box' : 'viewfarmer_box_empty'">
      <v-card-text>

    <v-layout>
      <v-flex xs3>
      <span class="accent--text" style="font-size: 14px; font-weight:700;"> Created Farmers </span>
    </v-flex>
    <v-spacer>
    </v-spacer>
    <v-flex xs2>
      Total FCS farmer
      <v-text-field
          v-model="totalFcsFarmers"
          readonly
      ></v-text-field>
      </v-flex>
      <v-spacer>
    </v-spacer>
    <v-flex  xs2>
          <v-btn
            xs2
            small
            @click="exportToExcel"
            v-if="$can('CAN_UPLOAD_FARMERS') || $can('CAN_APPROVE_FARMERS')"
            class="ml-2"
            outlined
          >
            Download
            <v-icon small class="ml-2">mdi-download</v-icon>
          </v-btn>
        </v-flex>

      <v-flex xs2></v-flex>
    <v-flex xs3>
       <v-text-field label="Search" v-model="search">
       </v-text-field>
     </v-flex>
     </v-layout>
      <v-data-table
                :headers="headers"
                :items="farmersList"
                :pagination.sync="pagination"
                :total-items="totalCharges"
                :loading="loading"
                :search="search"
                class="elevation-1"
              >
                <!-- Header formatting -->
                <template v-slot:headerCell="{ header }">
                  <span class="body-2 font-weight-regular accent--text">{{ header.text }}</span>
                </template>

                <!-- Rows formatting -->
                <template v-slot:item="props">
                  <tr>
                    <td>{{ props.item.farmerId }}</td>
                    <td>{{ props.item.firstName }} {{ props.item.middleName }} {{ props.item.lastName }}</td>
                    <td>{{ props.item.memberNumber }}</td>
                    <td>{{ props.item.mobileNumber }}</td>
                    <td>{{ props.item.acreage }}</td>
                    <td>{{ props.item.county?.name || '-' }}</td>
                    <td>{{ props.item.subCounty?.name || '-' }}</td>
                    <td>{{ props.item.status?.statusName || '-' }}</td>
                    <td class="actions">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
               <v-btn
                color="primary"
                dark
                v-on="on"
                text
                icon
                class="actions"
              >
                <v-icon class="secondary--text"> more_horiz </v-icon>
              </v-btn>
              </template>
              <v-list>
                <v-list-item  v-if="$can('CAN_UPLOAD_FARMERS') || $can('CAN_APPROVE_FARMERS')" @click="openViewDialog(props.item)">
                  <v-list-item-title> View </v-list-item-title>
                </v-list-item>
                <v-list-item  v-if="$can('CAN_UPLOAD_FARMERS')" @click="openEditDialog(props.item)">
                  <v-list-item-title> Edit </v-list-item-title>
                </v-list-item>
                <v-list-item  v-if=" $can('CAN_APPROVE_FARMERS')" @click="confirmAction(props.item, 'approve')">
                  <v-list-item-title> Approve </v-list-item-title>
                </v-list-item>
                <v-list-item  v-if=" $can('CAN_APPROVE_FARMERS')" @click="confirmAction(props.item, 'decline')">
                  <v-list-item-title> Decline </v-list-item-title>
                </v-list-item>
                <!-- <v-list-item  v-if="$can('CAN_UPLOAD_FARMER') || $can('CAN_APPROVE_FARMERS')" @click="exportToExcel">
                  <v-list-item-title> Download  </v-list-item-title>
                </v-list-item> -->
              </v-list>
            </v-menu>
          </td>
                    <!-- <td>
                      <v-list class="d-flex flex-row">
                        <v-list-item  v-if="$can('CAN_UPLOAD_FARMER') || $can('CAN_APPROVE_FARMERS')" @click="openViewDialog(props.item)">
                          <v-icon>mdi-eye</v-icon>
                        </v-list-item>

                        <v-list-item v-if=" $can('CAN_UPLOAD_FARMER')" @click="openEditDialog(props.item)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-list-item>

                        <v-list-item v-if="$can('CAN_UPLOAD_FARMER') || $can('CAN_APPROVE_FARMERS')" @click="exportToExcel">
                          <v-icon>mdi-download</v-icon>
                        </v-list-item>

                        <v-list-item v-if=" $can('CAN_APPROVE_FARMERS')" @click="confirmAction(props.item, 'approve')">
                          <v-icon>mdi-check-circle</v-icon>
                        </v-list-item>

                        <v-list-item v-if=" $can('CAN_APPROVE_FARMERS')" @click="confirmAction(props.item, 'decline')">
                          <v-icon>mdi-cancel</v-icon>
                        </v-list-item>
                      </v-list>
                    </td> -->
                  </tr>
                </template>

                <!-- No data slot   -->
                <template v-slot:no-data>
                  <p>No data found</p>
                  <v-btn color="primary" @click="getDataFromApi">Reload</v-btn>
                </template>
              </v-data-table>
      </v-card-text>
      <v-card-actions>
        <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
        <v-spacer></v-spacer>
        <v-pagination
        v-model="page"
        :length="numberOfLinks"
        color="secondary"
                class="accent--text logoutbtn"
      ></v-pagination>
      </v-card-actions>
    </div>
  </v-flex>
  </v-layout>

  <v-dialog v-model="bankDetailsDialog" persistent max-width="500" v-if="this.farmer !== null">
    <v-card>
      <v-card-title class="headline primary--text">Bank Details</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6" md="6">
            <h5> Account Name: </h5>
          </v-col>
          <v-col cols="6" md="6">
            {{ this.farmer !== null ? this.farmer.accountName : ''}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6">
            <h5> Account No: </h5>
          </v-col>
          <v-col cols="6" md="6">
           {{ this.farmer !== null ? this.farmer.accountNumber : ''}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6">
            <h5>  Bank Name: </h5>
          </v-col>
          <v-col cols="6" md="6">
            {{ this.farmer !== null ? this.farmer.institutionName : '' }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeBankDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="confirmDialog" max-width="500">
          <v-card>
            <v-card-title class="headline accent--text text-capitalize">{{ this.action }} Farmer Details</v-card-title>
            <v-card-text>
              <v-flex xs12>
                <p class="font-weight-regular subheading"> {{ confirmMessage }} </p>
              </v-flex>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="primary"
                text
                @click="confirmDialog = false"
                class="font-weight-bold"
              >
                Cancel
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                class="white--text logoutbtn"
                @click="approveOrDecline(confirmCherry)"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
  <v-dialog v-model="createFarmerDialog" persistent max-width="800">
  <v-card>
    <v-card-title class="headline primary--text">Create Farmer</v-card-title>
    <v-card-text>
      <v-form ref="saveform" v-model="valid" lazy-validation>

        <!-- Basic Names -->
        <v-layout>
          <v-flex xs5>
            <v-text-field
              label="First Name"
              v-model="farmer.firstName"
              :rules="[v => !!v || 'First Name is required']"
              required
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field
              label="Last Name"
              v-model="farmer.lastName"
              :rules="[v => !!v || 'Last Name is required']"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <!-- Optional: no rules -->
            <v-text-field label="Middle Name" v-model="farmer.middleName"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field
              label="Farmer Id"
              maxlength="10"
              v-model="farmer.farmerId"
              :rules="[
                v => !!v || 'Farmer ID is required',
                v => /^[a-zA-Z0-9]+$/.test(v) || 'Only letters and numbers allowed',
                v => v.length <= 10 || 'Maximum 10 characters allowed'
              ]"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Contact Info -->
        <v-layout>
          <v-flex xs5>
            <v-text-field
              name="mobileNumber"
              label="Mobile No"
              v-model="farmer.mobileNumber"
              :rules="[v => !!v || 'Mobile number is required', v => v.length >= 9 || 'Minimum 9 digits required']"
              maxlength="12"
              @keypress="validateContactPersonPhone"
              @paste="handlePasteContactPersonPhone"
              autocomplete="off"
              required
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field
              label="Member No"
              maxlength="10"
              v-model="farmer.memberNumber"
              :rules="[
                v => !!v || 'Member Number is required',
                v => /^[a-zA-Z0-9]+$/.test(v) || 'Only letters and numbers allowed',
                v => v.length <= 10 || 'Maximum 10 characters allowed'
              ]"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Personal Info -->
        <v-layout>
          <v-flex xs5>
            <v-text-field
              label="Full Name"
              v-model="farmer.fullName"
              :rules="[v => !!v || 'Full Name is required']"
              required
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-select
              label="Gender"
              v-model="farmer.gender"
              :items="['MALE', 'FEMALE']"
              :rules="[v => !!v || 'Gender is required']"
              required
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-select
              label="Payment Institution Type"
              v-model="farmer.institutionTupe"
              :items="['BANK', 'M-PESA','SACCO','MFB']"
              :rules="[v => !!v || 'Payment Institution Type is required']"
              required
            ></v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-select
              label="Variety"
              v-model="farmer.variety"
              :items="varietyList"
              item-text="name"
              item-value="id"
              :rules="[v => !!v || 'Variety is required']"
              required
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-select
              label="County"
              v-model="farmer.county"
              :items="countyList"
              item-text="name"
              item-value="id"
              @change="onCountyChange"
              :rules="[v => !!v || 'County is required']"
              required
            />
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-select
              label="Sub-County"
              v-model="farmer.subCounty"
              :items="filteredSubCountyList"
              item-text="name"
              item-value="id"
              :disabled="!farmer.county"
              @change="onSubCountyChange"
              :rules="[v => !!v || 'Sub-County is required']"
              required
            />
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-select
              label="Ward"
              v-model="farmer.ward"
              :items="filteredWardList"
              item-text="name"
              item-value="id"
              :disabled="!farmer.subCounty"
              :rules="[v => !!v || 'Ward is required']"
              required
            />
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5></v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field
              label="Village"
              v-model="farmer.village"
              :rules="[v => !!v || 'Village is required']"
              required
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <!-- Optional field, no rules -->
            <v-text-field label="KRA PIN" v-model="farmer.kraPin"></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field
              label="Year of Birth"
              type="number"
              v-model="farmer.YearOfBirth"
              :rules="[
                v => !!v || 'Year of Birth is required',
                v => /^\d+$/.test(v) || 'Enter a valid number',
                v => parseInt(v) > 0 || 'Year must be greater than zero',
                v => parseInt(v) < new Date().getFullYear() || 'Year must be less than current year'
              ]"
              required
            />
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field
              label="Number of Trees"
              type="number"
              v-model="farmer.numberOfTrees"
              :rules="[v => !!v || 'Number of Trees is required', v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field
              label="Acreage"
              v-model="farmer.acreage"
              type="text"
              :rules="[
                v => !!v || 'Acreage is required',
                v => /^[0-9]*\.?[0-9]+$/.test(v) && parseFloat(v) > 0 || 'Enter a number greater than zero'
              ]"
              required
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
          <!--    <v-select
              label="Grower"
              item-text="name"
              item-value="value"
              class="w-100"
              v-model="farmer.grower"
              :items="growerCodes"
              variant="solo-filled"
              hide-checkoffSettlementDetails
              return-object
              style="height: 60px; font-size: 16px;"
              :rules="[v => !!v || 'Grower is required']"
              required
            /> -->
            <v-autocomplete
            v-model="selectedParentOrganisation"
            :items="farmersocieties"
            item-text="organisationName"
            item-value="id"
            return-object
            label="Grower"
            placeholder="Start typing to search"
            dense
            clearable
            outlined
            :loading="loading"
            :search-input.sync="searchGrower"
            @input="onParentSelect"
          />
          </v-flex>
        </v-layout>

        <!-- Banking -->
        <v-layout>
          <v-flex xs5>
            <v-autocomplete
              v-model="farmer.farmerBankDetail.bankName"
              :items="farmerbanks"
              item-text="bankName"
              item-value="id"
              label="Bank Name"
              :rules="[v => !!v || 'Bank Name is required']"
              required
            />
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-select
              label="Currency"
              v-model="farmer.farmerBankDetail.currency"
              :items="['KES', 'USD']"
              :rules="[v => !!v || 'Currency is required']"
              required
            />
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field
              label="Account Name"
              v-model="farmer.farmerBankDetail.accountName"
              :rules="[v => !!v || 'Account Name is required']"
              required
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field
              label="Account Number"
              type="number"
              v-model="farmer.farmerBankDetail.account"
              :rules="[v => !!v || 'Account Number is required', v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Produce & Prices -->
        <v-layout>
          <v-flex xs5>
            <v-text-field
              label="Year 1 Produce (kg)"
              v-model="farmer.yearOneProduce"
              type="number"
              :rules="[v => !!v || 'Year 1 Produce is required', v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"
              required
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field
              label="Year 1 Price"
              v-model="farmer.yearOnePrice"
              type="number"
              :rules="[v => !!v || 'Year 1 Price is required', v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field
              label="Year 2 Produce (kg)"
              v-model="farmer.yearTwoProduce"
              type="number"
              :rules="[v => !!v || 'Year 2 Produce is required', v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"
              required
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field
              label="Year 2 Price"
              v-model="farmer.yearTwoPrice"
              type="number"
              :rules="[v => !!v || 'Year 2 Price is required', v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field
              label="Year 3 Produce (kg)"
              v-model="farmer.yearThreeProduce"
              type="number"
              :rules="[v => !!v || 'Year 3 Produce is required', v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"
              required
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field
              label="Year 3 Price"
              v-model="farmer.yearThreePrice"
              type="number"
              :rules="[v => !!v || 'Year 3 Price is required', v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Payment Institution (existing) -->
        <v-layout>
          <v-flex xs5>
            <v-autocomplete
              v-model="farmer.institutionCode"
              :items="banks"
              item-text="institutionName"
              item-value="institutionCode"
              label="Payment Institution"
              :rules="[v => !!v || 'Payment Institution is required']"
              required
            />
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field
              label="Payment Institution Account"
              v-model="farmer.accountNumber"
              type="number"
              :rules="[v => !!v || 'Payment Institution Account is required', v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>

      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn color="primary" text @click="createFarmerDialog = false">Close</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="saveRecord">CREATE</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
 <v-dialog v-model="editFarmerDialog" persistent max-width="800">
  <v-card>
    <v-card-title class="headline primary--text">Edit Farmer</v-card-title>
    <v-card-text>
      <v-form ref="editform" v-model="valid" lazy-validation>

        <!-- Basic Names -->
        <v-layout>
          <v-flex xs5>
            <v-text-field label="First Name" v-model="editFarmer.firstName" ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Last Name" v-model="editFarmer.lastName"></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field label="Middle Name" v-model="editFarmer.middleName"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>

<v-text-field
  label="Farmer Id"
  v-model="editFarmer.farmerId"
  type="text"
  maxlength="10"
  :rules="[
    v => !!v || 'Farmer ID is required',
    v => /^[a-zA-Z0-9]+$/.test(v) || 'Only letters and numbers are allowed',
    v => v.length <= 10 || 'Maximum 10 characters allowed'
  ]"
  required
></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Contact Info -->
        <v-layout>
          <v-flex xs5>
            <v-text-field label="Mobile No" v-model="editFarmer.mobileNumber" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  required></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Member No" v-model="editFarmer.memberNumber"  required></v-text-field>
          </v-flex>
        </v-layout>

        <!-- New Personal Info -->
        <v-layout>
          <v-flex xs5>
            <v-text-field label="Full Name" v-model="editFarmer.fullName"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-select label="Gender" v-model="editFarmer.gender" :items="['MALE', 'FEMALE']"></v-select>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs5>
            <v-select label="Payment Institution Type" v-model="editFarmer.institutionTupe" :items="['BANK', 'M-PESA','SACCO','MFB']"></v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-select
                label="Variety"
                v-model="editFarmer.variety"
                :items="varietyList"
                item-text="name"
                item-value="id"
                ></v-select>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-select
              label="County"
              v-model="editFarmer.county"
              :items="countyList"
              item-text="name"
              item-value="id"
              @change="onCountyChange"
            />
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
           <v-select
              label="Sub-County"
              v-model="editFarmer.subCounty"
              :items="filteredSubCountyList"
              item-text="name"
              item-value="id"
              :disabled="!editFarmer.county"
              @change="onSubCountyChange"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs5>
            <v-select
          label="Ward"
          v-model="editFarmer.ward"
          :items="filteredWardList"
          item-text="name"
          item-value="id"
          :disabled="!editFarmer.subCounty"
        />
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field label="Village" v-model="editFarmer.village"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="KRA PIN" v-model="editFarmer.kraPin"></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field label="Year of Birth" v-model="editFarmer.YearOfBirth" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  required></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Number of Trees" v-model="editFarmer.numberOfTrees" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  required></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
          <v-text-field
        label="Acreage"
        v-model="editFarmer.acreage"
        type="text"
        :rules="[
          v => !!v || 'Acreage is required',
          v => /^[0-9]*\.?[0-9]+$/.test(v) && parseFloat(v) > 0 || 'Enter a number greater than zero'
        ]"
        required
      ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <!-- <v-select
                        label="Grower"
                        item-text="name"
                        item-value="value"
                        class="w-100"
                        v-model="editFarmer.grower"
                        :items="growerCodes"
                        variant="solo-filled"
                        hide-checkoffSettlementDetails
                        return-object
                        style="height: 60px; font-size: 16px;"
                    /> -->
                    <v-text-field label="Grower" v-model="editFarmer.grower"  required></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Banking -->
        <v-layout>
          <v-flex xs5>
            <v-autocomplete v-model="editFarmer.farmerBankDetail.bankName" :items="farmerbanks" item-text="bankName" item-value="id" label="Bank Name"></v-autocomplete>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
             <v-select label="Currency" v-model="editFarmer.farmerBankDetail.currency" :items="['KES', 'USD']"></v-select>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs5>
            <v-text-field label="Account Name" v-model="editFarmer.farmerBankDetail.accountName"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Account Number" v-model="editFarmer.farmerBankDetail.account" type="number"  required></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Produce & Prices -->
        <v-layout>
          <v-flex xs5>
            <v-text-field label="Year 1 Produce (kg)" v-model="editFarmer.yearOneProduce"  type="number"  required></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Year 1 Price" v-model="editFarmer.yearOnePrice" type="number"   required></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field label="Year 2 Produce (kg)" v-model="editFarmer.yearTwoProduce" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  required></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Year 2 Price" v-model="editFarmer.yearTwoPrice" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  required></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field label="Year 3 Produce (kg)" v-model="editFarmer.yearThreeProduce" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  required></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Year 3 Price" v-model="editFarmer.yearThreePrice" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  required></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Payment Institution (existing) -->
        <v-layout>
          <v-flex xs5>
            <v-autocomplete v-model="editFarmer.institutionCode" :items="banks" item-text="institutionName" item-value="institutionCode" label="Payment Institution"></v-autocomplete>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Payment Institution Account" v-model="editFarmer.accountNumber" type="number"  required></v-text-field>
          </v-flex>
        </v-layout>

      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" text @click="editFarmerDialog = false">Close</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="updateFarmerRecord">Update</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="viewFarmerDialog" persistent max-width="800">
  <v-card>
    <v-card-title class="headline primary--text">View Farmer Details</v-card-title>
    <v-card-text>
      <v-form ref="editform" v-model="valid" lazy-validation>

        <!-- Basic Names -->
        <v-layout>
          <v-flex xs5>
            <v-text-field label="First Name" v-model="editFarmer.firstName" readonly></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Last Name" v-model="editFarmer.lastName" readonly></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field label="Middle Name" v-model="editFarmer.middleName" readonly></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>

<v-text-field
  label="Farmer Id"
  v-model="editFarmer.farmerId"
  type="text"
  maxlength="10"
  :rules="[
    v => !!v || 'Farmer ID is required',
    v => /^[a-zA-Z0-9]+$/.test(v) || 'Only letters and numbers are allowed',
    v => v.length <= 10 || 'Maximum 10 characters allowed'
  ]"
  readonly
></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Contact Info -->
        <v-layout>
          <v-flex xs5>
            <v-text-field label="Mobile No" v-model="editFarmer.mobileNumber" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  readonly></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Member No" v-model="editFarmer.memberNumber"   readonly></v-text-field>
          </v-flex>
        </v-layout>

        <!-- New Personal Info -->
        <v-layout>
          <v-flex xs5>
            <v-text-field label="Full Name" v-model="editFarmer.fullName" readonly></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-select label="Gender" v-model="editFarmer.gender" :items="['MALE', 'FEMALE']" readonly></v-select>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs5>
            <v-text-field label="Acreage" v-model="editFarmer.acreage" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  readonly></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-select
                label="Variety"
                v-model="editFarmer.variety"
                :items="varietyList"
                item-text="name"
                item-value="id"
                readonly></v-select>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-select
                label="County"
                v-model="editFarmer.county"
                :items="countyList"
                item-text="name"
                item-value="id"
                readonly></v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-select
                label="Sub-County"
                v-model="editFarmer.subCounty"
                :items="subCountyList"
                item-text="name"
                item-value="id"
                readonly></v-select>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field label="Number of Trees" v-model="editFarmer.numberOfTrees" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  readonly></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="KRA PIN" v-model="editFarmer.kraPin" readonly></v-text-field>
          </v-flex>
        </v-layout>
       <v-layout>
          <v-flex xs5>
            <v-text-field label="Account Name" v-model="editFarmer.farmerBankDetail.accountName"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Account Number" v-model="editFarmer.farmerBankDetail.account" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  required></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Produce & Prices -->
        <v-layout>
          <v-flex xs5>
            <v-text-field label="Year 1 Produce (kg)" v-model="editFarmer.yearOneProduce"  type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  readonly></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Year 1 Price" v-model="editFarmer.yearOnePrice" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  readonly></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field label="Year 2 Produce (kg)" v-model="editFarmer.yearTwoProduce" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  readonly></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Year 2 Price" v-model="editFarmer.yearTwoPrice" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  readonly></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs5>
            <v-text-field label="Year 3 Produce (kg)" v-model="editFarmer.yearThreeProduce" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  readonly></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Year 3 Price" v-model="editFarmer.yearThreePrice" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  readonly></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Payment Institution (existing) -->
        <!-- <v-layout>
          <v-flex xs5>
            <v-autocomplete v-model="editFarmer.institutionCode" :items="banks" item-text="institutionName" item-value="institutionCode" label="Payment Institution"></v-autocomplete>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Payment Institution Account" v-model="editFarmer.accountNumber" type="number" :rules="[v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero']"  required></v-text-field>
          </v-flex>
        </v-layout> -->

      </v-form>
    </v-card-text>
    <v-card-actions>
      <!-- <v-btn color="primary" text @click="viewFarmerDialog = false">Close</v-btn> -->
      <v-spacer></v-spacer>
      <!-- <v-btn color="primary" @click="updateFarmerRecord">Save</v-btn> -->
       <v-btn color="primary" text @click="viewFarmerDialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export default {
	name: 'viewfarmers',
	data: function () {
		return {
      headers: [
							{ text: 'ID Number', value: 'farmerId' },
							{ text: 'Name', value: 'fullName' },
							{ text: 'Member Number', value: 'memberNumber' },
							{ text: 'Mobile Number', value: 'mobileNumber' },
							{ text: 'Acreage', value: 'acreage' },
							{ text: 'County', value: 'county' },
							{ text: 'Sub-county', value: 'subCounty' },
							{ text: 'Status', value: 'status' }
						  ],

			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			farmers: [],
      confirmMessage: '',
      confirmFarmer: '',
      farmersList: [],
      downloadfarmersList: [],
      growerCodes: [],
			totalFcsFarmers: 0,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			farmerBankDetail: null,
			createFarmerDialog: false,
			bankDetailsDialog: false,
      confirmDialog: false,
			farmer: {
                subCounty: null,
                farmerBankDetail: {}
            },
            county: null,
            subCounty: null,
            ward: null,
            subCountyList: [],
            countyList: [],
            varietyList: [],
			banks: [],
      selectedParentOrganisation: null,
      farmersocieties: [],
      loading: false,
      searchGrower: '',
      searchTimeout: null,
			permissions: [],
      farmersocieties: [],
			organisationType: '',
			organisationId: '',
      editFarmerDialog: false,
      viewFarmerDialog: false,
      valid: false,
      loading: false,
      editFarmer: {
            id: 0,
            subCounty: '',
            farmerBankDetail: {
                bankName: '',
                currency: '',
                accountName: '',
                account: ''
            },
            firstName: '',
            lastName: '',
            middleName: '',
            farmerId: '',
            mobileNumber: '',
            memberNumber: '',
            fullName: '',
            gender: '',
            institutionTupe: '',
            variety: '',
            county: '',
            village: '',
            kraPin: '',
            YearOfBirth: '',
            numberOfTrees: '',
            acreage: '',
            grower: '',
            yearOneProduce: '',
            yearTwoProduce: '',
            yearThreeProduce: '',
            yearOnePrice: '',
            yearTwoPrice: '',
            yearThreePrice: '',
            institutionCode: '',
            accountNumber: ''
          },
      varietyList: [],
      countyList: [],
      subCountyList: [],
      growerCodes: [],
      filteredSubCountyList: [],
      filteredWardList: [],
    }


	},
	mounted () {
    this.getLoggedInUser ()
     this.getDataFromApi()
      .then(data => {
        // this.users = data.items
        // this.totalUsers = data.total
      })
		// this.getFarmers()
    this.getFarmerBanks ()
		this.getBanks()
		this.permissions = store.state.user.roleId.permissions
    // this.fetchSubCounties()
    this.fetchCounties ()
    this.fetchVarieties ()
    this.getGrowerCodes ()
	},
	watch: {
		farmers () {
			this.paginatedFiles = this.paginationMethod(this.farmers, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.farmers.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.farmers, val, this.numberOfItemsPerPage)
		},
     searchGrower(val) {
    if (this.searchTimeout) clearTimeout(this.searchTimeout)

    this.searchTimeout = setTimeout(() => {
      if (val && val.length >= 2) {
        this.getFcs(val)
      } else {
        this.farmersocieties = []
      }
    }, 300) // debounce delay
  }
	},

  pagination: {
      handler () {
        this.getDataFromApi()
          .then(data => {
            // this.users = data.items
            // this.totalUsers = data.total
          })
      },
      deep: true
    },
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.farmers.filter(farmer => { return (farmer.firstName !== null ? farmer.firstName.toLowerCase().includes(this.search.toLowerCase()) : ''.toLowerCase().includes(this.search.toLowerCase())) || (farmer.lastName === null ? ''.toLowerCase().includes(this.search.toLowerCase()) : farmer.lastName.toLowerCase().includes(this.search.toLowerCase())) || farmer.farmerId.toLowerCase().includes(this.search.toLowerCase()) || farmer.mobileNumber.includes(this.search) || farmer.memberNumber.includes(this.search) })
			}
		},
    filteredSubCountyList() {
      if (!this.farmer.county) {
        return [];
      }
      return this.subCountyList.filter(subCounty => subCounty.countyCode === this.farmer.countyCode);
    }
	},
	methods: {
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let items = this.getFarmers()
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 5000)
      })
    },
      getFcs(query) {
      this.loading = true
      const url = config.serverURI + `/organization/get-parent-organization?q=${encodeURIComponent(query)}`

      axios.get(url)
        .then((response) => {
          const results = response.data.map((x) => ({
            organisationName: `${x.organisationCode} - ${x.organisationName}`,
            id: x.id
          }))

          // Ensure selected item is still in the list
          if (this.selectedParentOrganisation && !results.find(org => org.id === this.selectedParentOrganisation.id)) {
            results.push(this.selectedParentOrganisation)
          }

          this.farmersocieties = results
        })
        .catch((error) => {
          this.$store.dispatch('alert/displayAlert', {
            snackbar: true,
            color: 'error',
            message: error.response?.message || 'Failed to fetch FCS'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onParentSelect(item) {
      // Handle selection
    },
            onCountyChange() {
          const countyId = this.farmer.county;
          if (!countyId) {
            this.filteredSubCountyList = [];
            this.farmer.subCounty = null;
            return;
          }
          const token = localStorage.getItem('token');
      const tokenconfig = {
          headers: {
              Authorization: `Bearer ${token}`
          }
      };
          console.log('countyId==>' +countyId)
          const url = config.serverURI + `/farmer/allsubcountybycounty/${countyId}`;
          axios.get(url, tokenconfig)
            .then(response => {
              this.filteredSubCountyList = response.data;
              console.log('Subcounty==>' +this.filteredSubCountyList)
              this.farmer.subCounty = null;
              this.filteredWardList = [];
              this.farmer.ward = null;
            })
            .catch(error => {
              console.error('Error fetching subcounties:', error.response || error);
            });
        },
    onSubCountyChange() {
      const subCountyId = this.farmer.subCounty;
      if (!subCountyId) {
        this.filteredWardList = [];
        this.farmer.ward = null;
        return;
      }
      const token = localStorage.getItem('token');
      const tokenconfig = {
          headers: {
              Authorization: `Bearer ${token}`
          }
      };

      fetch(config.serverURI +`/farmer/allwards/${subCountyId}`,tokenconfig)
        .then(response => response.json())
        .then(data => {
          this.filteredWardList = data;
          this.farmer.ward = null;
        })
        .catch(error => {
          console.error('Error fetching wards:', error);
        });
    },
    fetchCounties() {
      const token = localStorage.getItem('token');
      const tokenconfig = {
          headers: {
              Authorization: `Bearer ${token}`
          }
      };

      fetch(config.serverURI +'/farmer/allcounties', tokenconfig)
        .then(response => response.json())
        .then(data => {
          this.countyList = data;
        })
        .catch(error => {
          console.error('Error fetching counties:', error);
        });
    },
    async exportToExcel() {
  const url = config.serverURI + '/farmer/downloadfarmers/' + this.organisationId;

  axios.get(url)
    .then(response => {
      this.responseData = response.data;
      this.downloadfarmersList = response.data;

      // Now generate Excel
      const worksheet = XLSX.utils.json_to_sheet(this.downloadfarmersList);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Farmers");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });

      saveAs(blob, "downloaded_farmers.xlsx");
      this.message = 'Excel file downloaded successfully!';
      this.snackbar = true;
      this.snackbarColor = 'success';
    })
    .catch(error => {
      console.log('error', error.response);
      this.message = error.response.status;
      this.snackbar = true;
      this.snackbarColor = 'error';
    });
},
    openEditDialog(farmerData) {
      console.log('farmerData==>', JSON.stringify(farmerData));

      this.editFarmer = {
        id: farmerData.id,
        firstName: farmerData.firstName || '',
        lastName: farmerData.lastName || '',
        middleName: farmerData.middleName || '',
        farmerId: farmerData.farmerId || '',
        mobileNumber: farmerData.mobileNumber || '',
        memberNumber: farmerData.memberNumber || '',
        fullName: farmerData.fullName || '',
        gender: farmerData.gender || '',
        institutionTupe: 'BANK', // You may map this from backend if available editFarmer.grower
        variety: farmerData.productVariety || '',

        county: farmerData.county?.id || '',
        subCounty: farmerData.subCounty?.id || '',
        ward: farmerData.ward?.id || '',
        village: farmerData.organisation?.village || '',

        kraPin: farmerData.kraPin || '',
        YearOfBirth: farmerData.yearOfBirth || '1990',
        numberOfTrees: farmerData.numberOfTrees || 0,
        acreage: farmerData.acreage || 0,

        grower: farmerData.organisation.organisationCode || '',

        yearOneProduce: farmerData.yearOneProduce || 0,
        yearTwoProduce: farmerData.yearTwoProduce || 0,
        yearThreeProduce: farmerData.yearThreeProduce || 0,
        yearOnePrice: farmerData.yearOnePrice || 0,
        yearTwoPrice: farmerData.yearTwoPrice || 0,
        yearThreePrice: farmerData.yearThreePrice || 0,

        farmerBankDetail: {
          bankName: farmerData.farmerBankDetail?.bank?.id || '',  // v-model expects the bank ID
          currency: farmerData.farmerBankDetail?.currency || '',
          accountName: farmerData.farmerBankDetail?.accountName || '',
          account: farmerData.farmerBankDetail?.account || ''
        },

        institutionCode: farmerData.bankCode || '',
        accountNumber: farmerData.bankAccount || ''
      };

      console.log("editFarmer===>", JSON.stringify(this.editFarmer));
      this.editFarmerDialog = true;
    },
    validatePhone2 (e) {
			let value = e.target.value

			// Remove all non-digit characters
			value = value.replace(/[^0-9]/g, '')

			// Ensure it starts with 0
			if (value && value[0] !== '0') {
				value = '0' + value.replace(/^0+/, '')
			}

			// Limit to 10 digits
			value = value.slice(0, 10)

			// Assign the cleaned value back
			this.farmer.mobileNumber = value
		},
		validateContactPersonPhone (e) {
			// Get the character typed
			const char = String.fromCharCode(e.which || e.keyCode)

			// Allow only digits (0–9)
			if (!/^[0-9]$/.test(char)) {
				e.preventDefault()
				return
			}

			// Ensure first character is 0
			const value = e.target.value
			if (value.length === 0 && !/[072]/.test(char)) {
				e.preventDefault()
			}
		},
		handlePasteContactPersonPhone (e) {
			// Get pasted content
			const pastedData = (e.clipboardData || window.clipboardData).getData('text')

			// Reject if it contains non-digits
			if (!/^\d+$/.test(pastedData)) {
				e.preventDefault()
				return
			}

			// Reject if it doesn't start with 0, 7, or 2
			if (!/^[072]/.test(pastedData)) {
				e.preventDefault()
				return
			}

			// Optionally, reject if total length exceeds maxlength (12 here)
			const currentValue = this.farmer.mobileNumber || ''
			if ((currentValue.length + pastedData.length) > 12) {
				e.preventDefault()
			}
		},
    //  openEditDialog(farmerData) {
    //   // Populate the form with existing farmer data
    //    console.log('farmerData==>' + JSON.stringify(farmerData))
    //   this.editFarmer ={

    //         id: farmerData.id,
    //         subCounty: farmerData.subCounty || '',
    //         farmerBankDetail: {
    //             bankName: farmerData.bankName || '',
    //             currency: farmerData.currency || '',
    //             accountName:  farmerData.institutionCode || '',
    //             account: farmerData.account || ''
    //         },
    //         firstName: farmerData.firstName || '',
    //         lastName: farmerData.lastName || '',
    //         middleName: farmerData.middleName || '',
    //         farmerId: farmerData.farmerId || '',
    //         mobileNumber: farmerData.mobileNumber || '',
    //         memberNumber: farmerData.memberNumber ,
    //         fullName: farmerData.fullName || '',
    //         gender: farmerData.gender || '',
    //         institutionTupe: '',
    //         variety: farmerData.productVariety || '',
    //         county: farmerData.county || '',
    //         village: farmerData.village || '',
    //         kraPin: farmerData.kraPin || '',
    //         YearOfBirth: farmerData.yearOfBirth,
    //         numberOfTrees:  farmerData.numberOfTrees,
    //         acreage:  farmerData.acreage,
    //         grower: farmerData.growerCode || '',
    //         yearOneProduce: farmerData.yearOneProduce,
    //         yearTwoProduce: farmerData.yearTwoProduce,
    //         yearThreeProduce: farmerData.yearThreeProduce,
    //         yearOnePrice: farmerData.yearOnePrice,
    //         yearTwoPrice: farmerData.yearTwoPrice,
    //         yearThreePrice: farmerData.yearThreePrice,
    //         institutionCode: farmerData.bankCode || '',
    //         accountNumber: farmerData.bankAccount || ''
    //       }
    //       console.log("editFarmer===>" + JSON.stringify(this.editFarmer))
    //   this.editFarmerDialog = true
    // },
    openViewDialog(farmerData) {
      // Populate the form with existing farmer data
      this.editFarmer ={ //farmerBankDetail.account   farmerBankDetail.accountName farmerBankDetail.currency
            id: farmerData.id,
            subCounty: farmerData.subCounty || '',
            farmerBankDetail: {
                bankName: farmerData.bankName || '',
                currency: farmerData.currency || '',
                accountName:  farmerData.accountName || '',
                account: farmerData.account || ''
            },
            firstName: farmerData.firstName || '',
            lastName: farmerData.lastName || '',
            middleName: farmerData.middleName || '',
            farmerId: farmerData.farmerId || '',
            mobileNumber: farmerData.mobileNumber || '',
            memberNumber: farmerData.memberNumber || '',
            fullName: farmerData.fullName || '',
            gender: farmerData.gender || '',
            institutionTupe: '',
            variety: farmerData.productVariety || '',
            county: farmerData.county || '',
            village: '',
            kraPin: farmerData.kraPin || '',
            YearOfBirth: farmerData.yearOfBirth,
            numberOfTrees:  farmerData.numberOfTrees,
            acreage:  farmerData.acreage,
            grower: farmerData.growerCode || '',
            yearOneProduce: farmerData.yearOneProduce,
            yearTwoProduce: farmerData.yearTwoProduce,
            yearThreeProduce: farmerData.yearThreeProduce,
            yearOnePrice: farmerData.yearOnePrice,
            yearTwoPrice: farmerData.yearTwoPrice,
            yearThreePrice: farmerData.yearThreePrice,
            institutionCode: farmerData.bankCode || '',
            accountNumber: farmerData.bankAccount || ''
          }
      this.viewFarmerDialog = true
    },

    async updateFarmerRecord() {
      if (this.$refs.editform.validate()) {
        this.loading = true
        const payload =  {
            id: this.editFarmer.id,
            subCounty: this.editFarmer.subCounty.id,
            farmerBankDetail: {
                bankName: this.editFarmer.bankName,
                currency: this.editFarmer.currency,
                accountName: this.editFarmer.fullName,
                account: this.editFarmer.account,
            },
            firstName: this.editFarmer.firstName,
            lastName: this.editFarmer.lastName,
            middleName: this.editFarmer.middleName,
            farmerId: this.editFarmer.farmerId,
            mobileNumber: this.editFarmer.mobileNumber,
            memberNumber: this.editFarmer.memberNumber,
            fullName: this.editFarmer.fullName,
            gender: this.editFarmer.gender,
            institutionTupe: 'BANK',
            variety: this.editFarmer.productVariety,
            county: this.editFarmer.county.id,
            ward: this.editFarmer.ward.id,
            village: this.editFarmer.village,
            kraPin: this.editFarmer.kraPin,
            YearOfBirth: this.editFarmer.yearOfBirth,
            numberOfTrees: parseFloat(this.editFarmer.numberOfTrees),
            acreage: parseFloat(this.editFarmer.acreage),
            grower: this.editFarmer.growerCode,
            yearOneProduce: parseInt(this.editFarmer.yearOneProduce) || null,
            yearTwoProduce: parseInt(this.editFarmer.yearTwoProduce) || null,
            yearThreeProduce: parseInt(this.editFarmer.yearThreeProduce) || null,
            yearOnePrice:  parseFloat(this.editFarmer.yearOnePrice) || null,
            yearTwoPrice:  parseFloat(this.editFarmer.yearTwoPrice) || null,
            yearThreePrice: parseFloat( this.editFarmer.yearThreePrice) || null,
            institutionCode: this.editFarmer.institutionCode,
            accountNumber: this.editFarmer.bankAccount
          }
        console.log('Update payload:', payload)

        try {
          const response = await axios.post(config.serverURI + '/farmer/update/'+this.editFarmer.id, payload)
          console.log('Farmer updated successfully:', response.data)

          this.editFarmerDialog = false
          this.loading = false

          // Emit event to parent component to refresh data
          this.$emit('farmer-updated')

          // Show success message
          this.$emit('show-message', {
            type: 'success',
            text: 'Farmer updated successfully'
          })

        } catch (error) {
          console.error('Update error:', error)
          this.loading = false

          // Show error message
          this.$emit('show-message', {
            type: 'error',
            text: 'Failed to update farmer. Please try again.'
          })
        }
      } else {
        console.warn('Form is invalid')
      }
    },
    getFarmers () {
          const url = config.serverURI + '/farmer/allfarmers/'+this.organisationId
          axios.get(url, {})
            .then(response => {
              this.responseData = response.data
              console.log('Response data ===>' + JSON.stringify(this.responseData))
                        this.farmersList = response.data
                        this.totalFcsFarmers = this.farmersList.length
            })
            .catch(error => {
              console.log('error', error.response)
              this.message = error.response.status
              this.snackbar = true
              this.snackbarColor = 'error'
            })
          return this.farmersList
        },
        async saveRecord() {
            try {
            const isValid = await this.$refs.saveform.validate();
            if (!isValid) {
                this.$toast.error('Please fill out all required fields correctly.');
                return;
            }
            console.log('Form Data ==>' + JSON.stringify(this.farmer))
            const url = config.serverURI + '/farmer/store'
             const response = await axios.post(url, this.farmer, {
                 headers: {
                 'Content-Type': 'application/json'
                 }
             });
                 // Reset the form if needed:
                 this.farmer = {};
                 this.farmers = response.data
                 this.$refs.saveform.reset();
                 this.createFarmerDialog = false
                 this.message = 'Record Created successfully!';
                  this.snackbar = true;
                  this.snackbarColor = 'success';
                  this.$router.go()
                  this.getFarmers()
            } catch (error) {
            console.error(error);
            this.$toast.error('Error saving farmer: ' + (error.response?.data?.message || error.message));
            }
        },

		getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
			this.organisationType = this.theUser.organisation.organisationType.name
			this.organisationId = this.theUser.organisation.id
			// this.curUserN = this.curUser.firstName
      console.log('organisationId ==>' + this.organisationId)
		},
    confirmAction(item, action) {
          this.confirmFarmer = { ...item };
          this.confirmDialog = true;
          this.action = action;
          console.log('Farmer==>'+ JSON.stringify(this.confirmFarmer))
          if (action === 'approve') {
            this.confirmMessage = 'Approve Farmer Details ' + this.confirmFarmer.firstName + '  ' + this.confirmFarmer.middleName + '  ' +  this.confirmFarmer.lastName + '?';
          } else if (action === 'decline') {
            this.confirmMessage = 'Decline Farmer Details ' + this.confirmFarmer.firstName + '  ' + this.confirmFarmer.middleName + '  ' +  this.confirmFarmer.lastName + '?';
          } else {
            console.error(action + ' action not supported');
          }
        },
        approveOrDecline (item) {
              if (this.action === 'approve') {
                  this.approve(item)
              } else if (this.action === 'decline') {
                  this.decline(item)
              } else {
                  console.error('Function not supported')
              }
          },
          approve (item) {
            this.approveloading = true
            const payload = {
                    action: 'approve',
                    confirmFarmer: this.confirmFarmer.id
                    };
                console.log('Form Data:', payload);
                axios.post(config.serverURI + '/farmer/approve', payload)
                    .then(response => {
                        console.log('Form submitted:', response.data);
                        this.editDialog = false
                        this.getFarmers()
                        this.$router.go()
                         this.message = 'Farmer Approved successfully!'
                  this.snackbar = true
                  this.snackbarColor = 'success'
                    })
                    .catch(error => {
                        console.error('Submission error:', error);
                    });
          },
          decline (item) {
            this.declineloading = true
            const payload = {
                    action: 'decline',
                    confirmFarmer: this.confirmFarmer.id
                    };
                console.log('Form Data:', payload);
                axios.post(config.serverURI + '/farmer/approve', payload)
                    .then(response => {
                        console.log('Form submitted:', response.data);
                        this.editDialog = false
                        this.$router.go()
                        this.reloadComponent()
                        this.getFarmers()
                        this.$router.go()
                        this.message = 'Farmer Approval Declined successfully!'
                  this.snackbar = true
                  this.snackbarColor = 'success'
                    })
                    .catch(error => {
                        console.error('Submission error:', error);
                    });
           },

        getGrowerCodes () {
          const url = config.serverURI + '/organization/get-fcs'
          axios.get(url)
            .then(response => {
              console.log('FCS - ', response.data)
              // this.growerCodes = response.data
              response.data.forEach(x => {
                // console.log('->> ', x.organisationCode)
                this.growerCodes.push(x.organisationCode)
              })
            })
            .catch(error => {
              // Request failed.
              console.log('error', error.response)
              this.message = error.response.status
              this.snackbar = true
              this.snackbarColor = 'error'
            })
          return this.growerCodes
		   },
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
        fetchSubCounties () {
			const url = config.serverURI + '/farmer/subcounties'
			axios.get(url)
				.then(response => {
					console.log('FCS - ', response.data)
					// this.growerCodes = response.data
					response.data.forEach(x => {
						// console.log('->> ', x.subCountyName)
						this.subCountyList.push(x.subCountyName)
					})
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.subCountyList
		   },
           fetchVarieties () {
			const url = config.serverURI + '/farmer/varieties'
			axios.get(url)
				.then(response => {
					console.log('FCS - ', response.data)
					// this.growerCodes = response.data
					response.data.forEach(x => {
						// console.log('->> ', x.countyName)
						this.varietyList.push(x.variety)
					})
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.varietyList
		   },
       fetchCounties () {
        const url = config.serverURI + '/farmer/allcounties';
        axios.get(url)
          .then(response => {
            console.log('FCS - ', response.data);
            this.countyList = response.data; // Use full objects
          })
          .catch(error => {
            console.log('error', error.response);
            this.message = error.response?.status || 'Network error';
            this.snackbar = true;
            this.snackbarColor = 'error';
          });
      },
      //      fetchCounties () {
			// const url = config.serverURI + '/farmer/allcounties'
			// axios.get(url)
			// 	.then(response => {
			// 		console.log('FCS - ', response.data)
			// 		response.data.forEach(x => {
			// 			this.countyList.push(x.name)
			// 		})
			// 	})
			// 	.catch(error => {
			// 		// Request failed.
			// 		console.log('error', error.response)
			// 		this.message = error.response.status
			// 		this.snackbar = true
			// 		this.snackbarColor = 'error'
			// 	})
			// return this.countyList
		  //  },
		// getFarmers () {
		// 	const url = config.serverURI + '/upload/cherry/getFarmers/' + this.organisationId
		// 	axios.get(url)
		// 		.then(response => {
		// 			this.farmers = response.data
		// 		})
		// 		.catch(error => {
		// 			console.log('error', error.response)
		// 		})
		// },

		viewBankDetails (item) {
			this.bankDetailsDialog = true
			this.farmer = item
			// this.farmerBankDetail = item.farmerBankDetail
			console.log(this.farmer)
		},
		closeBankDialog () {
			// this.farmer = null
			this.bankDetailsDialog = false
		},
		showEditDialog (farmer) {
			this.createFarmerDialog = true
			this.farmer = farmer
		},
		editRecord () {
			if (this.$refs.editform.validate()) {
				const url = config.serverURI + '/farmer/edit'
				axios.post(url, {
					id: this.farmer?.id,
					firstName: this.farmer?.firstName,
					lastName: this.farmer?.lastName,
					middleName: this.farmer?.middleName,
					memberNumber: this.farmer?.memberNumber,
					gender: this.farmer?.gender,
					farmerId: this.farmer?.farmerId,
					growerId: this.farmer?.organizationId,
					bankCode: this.farmer?.institutionCode,
					account: this.farmer?.accountNumber,

					mobileNumber: this.farmer?.mobileNumber

				})
					.then(response => {
						// console.log('Response', response.data)
						if (response.data.error !== false) {
							this.message = response.data.message
							this.snackbar = true
							this.snackbarColor = 'error'
							console.log('Error is ' + this.message)
							return
						}
						this.$refs.editform.resetValidation()
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'primary'
						this.createFarmerDialog = false
					})
					.catch(error => {
						console.log('error', error.response)
						this.message = error.response.message
						this.snackbar = true
						this.snackbarColor = 'error'
					})

				this.getFarmers()
			}
		},

		getBanks () {
			const url = config.serverURI + '/farmer/institutions'
			axios.get(url)
				.then(response => {
					this.banks = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},
    getFarmerBanks () {
			const url = config.serverURI + '/farmer/banks'
			axios.get(url)
				.then(response => {
					this.farmerbanks = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},

		canEditFarmer () {
			return this.hasPerm('CAN_UPDATE_FARMER')
		},
		downloadStatement (farmer) {
			const url = config.serverURI + `/farmer/loan_statement/${farmer.organizationId}/${farmer.id}`
			this.loading = true
			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					this.loading = false
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = `loanstatement_${farmer.id}.pdf`
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					this.loading = false
					console.log('error', error.response)
				})
		}
	}
}

</script>
<style>
.viewfarmer_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.viewfarmer_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table  tbody  tr >  td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}
.pagination>li.active>.page-link {
  background: #00513B;
  color: #fff;
}
</style>
